import { render } from "./AssignSalesperson.vue?vue&type=template&id=05c22876&scoped=true"
import script from "./AssignSalesperson.vue?vue&type=script&lang=js"
export * from "./AssignSalesperson.vue?vue&type=script&lang=js"

import "./AssignSalesperson.vue?vue&type=style&index=0&id=05c22876&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c22876"]])

export default __exports__